<div *ngIf="reports.length" class="alert alert-info mt-10 cursor-pointer" (click)="open()">
  {{reports.length}} {reports.length, plural, >1 {users have} other {user has}} marked this {{type | lowercase}} as
  inappropriate.
</div>
